import { Component, EventEmitter, Input, Output, SimpleChange } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { UnitOfTime } from '../../models/enums/unit-of-time';
import { NgFor } from '@angular/common';

type CallBackScheduledUnitPair = {
  callBackScheduledat: number;
  unit: UnitOfTime;
};
@Component({
  selector: 'app-minutes-time-unit-mapping',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    NgFor
  ],
  templateUrl: './minutes-time-unit-mapping.component.html',
  styleUrl: './minutes-time-unit-mapping.component.scss'
})
export class MinutesTimeUnitMappingComponent {
  @Input() minutesValue!: number;
  @Input() labelValue!: string;
  @Output() minutesValueChanged:EventEmitter<number> = new EventEmitter<number>();
  missedCallSettingsForm!: FormGroup;

  timeUnits = Object.values(UnitOfTime);
  private timeUnitToMultiplicationFactor = new Map<UnitOfTime, number>([
    [UnitOfTime.MINUTES, 1],
    [UnitOfTime.HOURS, 60],
    [UnitOfTime.DAYS, 60 * 24]
  ]);

  constructor(
    private formBuilder: FormBuilder
  ) {
    
  }

  ngOnInit() {
    this.initForm();
    this.missedCallSettingsForm.valueChanges.subscribe(changes => {
      const timeUnit: UnitOfTime = changes['timeUnit'];

      const updatedMinuteValue = changes['callbackScheduledAt'] * (this.timeUnitToMultiplicationFactor.get(timeUnit) || 1);
      this.minutesValueChanged.emit(updatedMinuteValue);
  });
  }


  private initForm() {
    const formatedScheduledAt = this.getTimeUnit(this.minutesValue);
    console.log(formatedScheduledAt)
    this.missedCallSettingsForm = this.formBuilder.group({
      callbackScheduledAt: [formatedScheduledAt.callBackScheduledat, Validators.required],
      timeUnit: [formatedScheduledAt.unit, Validators.required]
    })
  }

  private getTimeUnit(callBackScheduedAt: number): CallBackScheduledUnitPair {
    if (!callBackScheduedAt) {
      return { callBackScheduledat: 0, unit: UnitOfTime.MINUTES }
    }

    const sortedMap = [...this.timeUnitToMultiplicationFactor.entries()].sort((a: [UnitOfTime, number], b: [UnitOfTime, number]) => {
      return b[1] - a[1]
    });


    for (const multiplifactorPair of sortedMap) {
      const callBackScheduledAtInTimeUnit = callBackScheduedAt / multiplifactorPair[1];
      if (callBackScheduledAtInTimeUnit > 1 && callBackScheduledAtInTimeUnit % 1 == 0) {
        console.log(callBackScheduledAtInTimeUnit)
        return { callBackScheduledat: parseFloat(callBackScheduledAtInTimeUnit.toFixed(2)), unit: multiplifactorPair[0] }
      }
    }

    return { callBackScheduledat: callBackScheduedAt, unit: UnitOfTime.MINUTES }
  }
}
